import Models from "@models";
import { defaultInstance } from "./instances";

export const fetchUser: (id?: number) => Promise<any> = async (id) =>
  await defaultInstance.get<Models.User>(`/users/${id}`);

export const fetchAll: () => Promise<any> = async () =>
  await defaultInstance.get<Models.User[]>(`/users/`);
